import {Component, Input, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {
    Aangifte,
    AangifteBerekening,
    AangifteRapport, Adres, BokkzAlgDataService,
    BokkzIbDataService,
    Box3Berekening,
    IncomeTaxEntity, OgBerekendeWaarde,
    OpbouwBox3, OpbouwInkomenBox3,
    SpecificatieBox3
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BehaviorSubject, filter, Subscription} from "rxjs";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { Box3InkomenComponent } from './box3-inkomen/box3-inkomen.component';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box3',
  templateUrl: './box3.component.html',
  styleUrls: ['./box3.component.scss'],
    imports: [
        SharedUiDetailsModule,
        DecimalPipe,
        ReactiveFormsModule,
        SharedUiFormControlsModule,
        CommonModule,
        SharedUiAlertModule,
        Box3InkomenComponent
    ]
})
export class Box3Component implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);

    specBox3FormGroup = this.fb.group<AangifteRapport>({});
    specBox3 = {} as AangifteRapport;
    berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    berekening = {} as AangifteBerekening;
    waardePerOGNederlandArray: FormArray | null = null;
    waardePerOGBuitenlandArray: FormArray | null = null;


    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.specBox3FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBox3: this.fb.group<SpecificatieBox3>(({
                opbouw: this.fb.group<OpbouwBox3>({
                    verminderingVoordeelSparenEnBeleggen: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVermindering: null as unknown as number,
                    tijdsEvenredigeVermindering: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    heffingsvrijVermogenAangever: null as unknown as number,
                    heffingsvrijVermogenPartner: null as unknown as number,
                    rendementsGrondslag: null as unknown as number,
                    banktegoedenNederland: 0,
                    banktegoedenBuitenland: 0,
                    beleggingen: null as unknown as number,
                    groeneBeleggingen: null as unknown as number,
                    vrijstellingGroeneBeleggingen: null as unknown as number,
                    groeneBeleggingenBanktegoeden: null as unknown as number,
                    groeneBeleggingenEffecten: null as unknown as number,
                    saldoGroeneBeleggingen: null as unknown as number,
                    onroerendeZaken: 0,
                    waardePerOGNederland: this.fb.array<OgBerekendeWaarde>([
                        this.fb.group<OgBerekendeWaarde>({
                            adres: this.fb.group<Adres>({
                                straat: '' as unknown as string,
                                huisNummer: null as unknown as number,
                                huisNummerToevoeging: '' as unknown as string,
                                postcode: '' as unknown as string,
                                woonplaats: '' as unknown as string,
                                landCode: '' as unknown as string,
                            }),
                            berekendeWaarde: null as unknown as number,
                            berekendeWaardeEindDatum: null as unknown as number,
                            percentageBelang: null as unknown as number,
                            aandeelBerekendeWaarde: null as unknown as number,
                            schuld: null as unknown as number,
                            waardeNaarTijdsgelang: null as unknown as number,
                            schuldNaarTijdsgelang: null as unknown as number,
                            waardeMinusSchuld: null as unknown as number,
                            waardeMinusSchuldNaarTijdsgelang: null as unknown as number,
                            datumVerkoop: '' as unknown as Date,
                            datumAankoop: '' as unknown as Date,
                            werkelijkRendement: null as unknown as number,
                        })
                    ]),
                    waardePerOGBuitenland: this.fb.array<OgBerekendeWaarde>([
                        this.fb.group<OgBerekendeWaarde>({
                            adres: this.fb.group<Adres>({
                                straat: '' as unknown as string,
                                huisNummer: null as unknown as number,
                                huisNummerToevoeging: '' as unknown as string,
                                postcode: '' as unknown as string,
                                woonplaats: '' as unknown as string,
                                landCode: '' as unknown as string,
                            }),
                            berekendeWaarde: null as unknown as number,
                            percentageBelang: null as unknown as number,
                            aandeelBerekendeWaarde: null as unknown as number,
                            schuld: null as unknown as number,
                            waardeNaarTijdsgelang: null as unknown as number,
                            schuldNaarTijdsgelang: null as unknown as number,
                            waardeMinusSchuld: null as unknown as number,
                            waardeMinusSchuldNaarTijdsgelang: null as unknown as number,
                            datumVerkoop: '' as unknown as Date,
                            datumAankoop: '' as unknown as Date,
                        })
                    ]),
                    vorderingen: null as unknown as number,
                    kapitaalverzekeringen: null as unknown as number,
                    periodiekeUitkeringen: null as unknown as number,
                    crytoBezittingen: null as unknown as number,
                    overigeBezittingen: null as unknown as number,
                    premieDepots: null as unknown as number,
                    bouwDepots: null as unknown as number,
                    contantGeld: null as unknown as number,
                    nettoPensioen: null as unknown as number,
                    schuldenNederlandsOG: 0,
                    schuldenBuitenlandsOG: null as unknown as number,
                    overigeSchulden: null as unknown as number,
                    totaleSchulden: null as unknown as number,
                    schuldenDrempel: 0,
                    schuldenNaDrempel: null as unknown as number,
                })
            } as SpecificatieBox3))
        } as AangifteRapport));
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
            box3: this.fb.group<Box3Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwInkomenBox3>(({
                    voordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    rendementsGrondslagNaVerdeling: null as unknown as number,
                    rendementsGrondslag: null as unknown as number,
                } as OpbouwInkomenBox3)),
            } as Box3Berekening)),
        } as AangifteBerekening));
        this.waardePerOGNederlandArray = this.getWaardePerOGNederlandControls();
        this.waardePerOGBuitenlandArray = this.getWaardePerOGBuitenlandControls();
    }

    getWaardePerOGNederlandControls(): FormArray | null {
        return this.specBox3FormGroup.get('specificatieBox3.opbouw.waardePerOGNederland') as FormArray | null;
    }

    getWaardePerOGBuitenlandControls(): FormArray | null {
        return this.specBox3FormGroup.get('specificatieBox3.opbouw.waardePerOGBuitenland') as FormArray | null;
    }

    public ngOnInit(): void {
       this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specBox3 = value;
                    this.specBox3FormGroup.patchValue(this.specBox3)
                    this.waardePerOGNederlandArray = this.getWaardePerOGNederlandControls();
                    this.waardePerOGBuitenlandArray = this.getWaardePerOGBuitenlandControls();
                    this.specBox3FormGroup.get('specificatieBox3.opbouw.groeneBeleggingen')?.valueChanges.subscribe(groeneBeleggingen => {
                        this.updateSaldoGroeneBeleggingen();
                    });

                    this.specBox3FormGroup.get('specificatieBox3.opbouw.vrijstellingGroeneBeleggingen')?.valueChanges.subscribe(vrijstellingGroeneBeleggingen => {
                        this.updateSaldoGroeneBeleggingen();
                    });
                });
                this.disableFormGroup(this.specBox3FormGroup);
            }
        });
       this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {this.handleUrlChange(event.urlAfterRedirects)});
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

  private hasUnsavedChanges(): boolean {
    return false;
  }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    hasBox3Detail(property: keyof OpbouwBox3): boolean {
        const opbouw = this.specBox3.specificatieBox3?.opbouw;
        if (!opbouw) return false;

        return opbouw[property] !== undefined && opbouw[property] > 0;
    }

    private updateSaldoGroeneBeleggingen() {
        const groeneBeleggingen = this.specBox3FormGroup.get('specificatieBox3.opbouw.groeneBeleggingen')?.value || 0;
        const vrijstellingGroeneBeleggingen = this.specBox3FormGroup.get('specificatieBox3.opbouw.vrijstellingGroeneBeleggingen')?.value || 0;

        const saldo = groeneBeleggingen - vrijstellingGroeneBeleggingen;

        this.specBox3FormGroup.get('specificatieBox3.opbouw.saldoGroeneBeleggingen')?.setValue(saldo, {emitEvent: false});
    }


}


